import React from 'react';
import { Storage } from 'react-jhipster';

import { connect } from 'react-redux';
import { Alert, Col, Row, Button } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { Translate, translate, getUrlParameter } from 'react-jhipster';
import { RouteComponentProps, Redirect } from 'react-router-dom';

import { IRootState } from 'app/shared/reducers';
import { handlePasswordResetFinish, reset } from '../password-reset.reducer';
import MessageModal from 'app/shared/message/message-modal';
import { SUCCESS } from 'app/config/constants';
import { login } from 'app/shared/util/utilities';

export interface IPasswordResetFinishProps
  extends StateProps,
    DispatchProps,
    RouteComponentProps<{ id: any; key: string; phone: string }> {}

export interface IPasswordResetFinishState {
  password: string;
  showMessage: boolean;
  visible: boolean;
  color: string;
  message: string;
  redirectLogin: boolean;
  isMobile: boolean;
}

export class PasswordResetFinishPage extends React.Component<IPasswordResetFinishProps, IPasswordResetFinishState> {
  state: IPasswordResetFinishState = {
    password: '',
    visible: false,
    color: 'info',
    message: '',
    redirectLogin: false,
    isMobile: false,
    showMessage: false
  };

  componentWillMount() {
    window['is_mobile']();
    this.setState({
      isMobile: window['isMobile']
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.responseFinish !== nextProps.responseFinish) {
      const { responseFinish } = nextProps;
      if (responseFinish && responseFinish.status === 'SUCCESS') {
        this.setState({
          showMessage: true
        });
        let timerId = setTimeout(() => {
          this.setState({
            showMessage: false,
            redirectLogin: true
          });
        }, 3000);
      } else if (responseFinish.status) {
        this.setState({
          visible: true,
          color: 'danger',
          message: responseFinish.message && responseFinish.message !== 'ERROR' ? responseFinish.message : 'Lỗi!'
        });
      }
    }
  }

  componentWillUnmount() {
    //this.props.reset();
  }

  handleValidSubmit = (event, values) => {
    const id = this.props.match.params.id;
    let phone = this.props.responseInit ? this.props.responseInit.mobile : '';
    let password = values.newPassword;
    if (password && password.indexOf(' ') > -1) {
      this.setState({
        visible: true,
        color: 'danger',
        message: 'Mật khẩu không được chứa khoảng trắng.'
      });
    } else {
      let key = this.props.responseSendOtp ? this.props.responseSendOtp.resetKey : '';
      this.props.handlePasswordResetFinish(id, values.newPassword, key, phone);
    }
  };

  onDismiss = () => {
    this.setState({ visible: false });
  };

  getResetForm() {
    return (
      <AvForm onValidSubmit={this.handleValidSubmit}>
        <AvField
          name="newPassword"
          label={translate('global.form.newpassword.label')}
          placeholder={translate('global.form.newpassword.placeholder')}
          type="password"
          validate={{
            required: { value: true, errorMessage: translate('global.messages.validate.newpassword.required') },
            minLength: { value: 8, errorMessage: translate('global.messages.validate.newpassword.minlength') },
            maxLength: { value: 30, errorMessage: translate('global.messages.validate.newpassword.maxlength') },
            pattern: {
              value: '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{12,}$',
              errorMessage: translate('global.messages.validate.newpassword.strengthmessage')
            }
          }}
        />
        <AvField
          name="confirmPassword"
          label={translate('global.form.confirmnewpassword.label')}
          placeholder={translate('global.form.confirmnewpassword.placeholder')}
          type="password"
          validate={{
            required: { value: true, errorMessage: translate('global.messages.validate.confirmpassword.required') },
            minLength: { value: 8, errorMessage: translate('global.messages.validate.confirmpassword.minlength') },
            maxLength: { value: 30, errorMessage: translate('global.messages.validate.confirmpassword.maxlength') },
            match: { value: 'newPassword', errorMessage: translate('global.messages.error.dontmatch') }
          }}
        />
        <Button className="btn-register" type="submit" block>
          <Translate contentKey="reset.finish.form.button">Reset password</Translate>
        </Button>
      </AvForm>
    );
  }

  render() {
    if (this.state.redirectLogin) {
      // login(this.props.config);
      return (
        <Redirect
          push
          to={{
            pathname: `/success`,
            state: {
              config: this.props.config,
              message: 'Đặt lại mật khẩu thành công!'
            }
          }}
        />
      );
    }
    return (
      <div>
        {/*<MessageModal type={SUCCESS} showModal={this.state.showMessage} message={'Chúc mừng bạn đã đặt lại mật khẩu thành công'} />*/}
        <Row className="justify-content-center">
          <Col className="box-password">
            <h2 className="text-center font-weight-bold" id="register-title">
              <Translate contentKey="reset.finish.title">Reset password</Translate>
            </h2>
            <h5 className="text-center txtContent">
              <Translate contentKey="password.txtContent" />
            </h5>
            <p style={{ marginTop: '10px', textAlign: 'center' }}>
              Tài khoản: <strong>{this.props.responseInit ? this.props.responseInit.fullname : ''}</strong>{' '}
            </p>
            <Alert color={this.state.color} isOpen={this.state.visible} toggle={this.onDismiss}>
              {this.state.message}
            </Alert>
            {this.getResetForm()}
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = ({ passwordReset, applicationProfile, sendotp }: IRootState) => ({
  responseFinish: passwordReset.responseFinish,
  config: applicationProfile.config,
  response: passwordReset.response,
  responseReSend: passwordReset.responseReSend,
  responseInit: passwordReset.responseInit,
  responseSendOtp: sendotp.response
});

const mapDispatchToProps = { handlePasswordResetFinish, reset };
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PasswordResetFinishPage);
